import { adminApi } from '@admin/redux/adminApi';
import { combineReducers } from 'redux';

import { broadbandApi } from '../../../Broadband/js/redux/broadbandApi';
import broadband from '../../../Broadband/js/redux/broadbandSlice';
import shared from './sharedSlice';

const rootReducer = combineReducers({
    broadband,
    shared,
    // Unable to declare API in the broadband slice directly,
    // because 'state.' prefix is added causing incorrect state name, i.e. 'state.broadband/api'.
    [adminApi.reducerPath]: adminApi.reducer,
    [broadbandApi.reducerPath]: broadbandApi.reducer
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
